import { KiteGrid, KiteGridCell } from '@kite/react-kite';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import { SmartLink } from '../SmartLink/SmartLink';
import './ImageList.scss';

export interface ImageListInputs {
    image?: any;
    learnMoreLink: string;
    title: string;
    text: string;
    imageAlt: string;
}

export const ImageList = ({ inputs }: { inputs: ImageListInputs }) => {
    const gImage = inputs.image ? getImage(inputs.image.localFile) : undefined;
    return (
        <section className="paragraph__image_list kite-container">
            <KiteGrid>
                <KiteGridCell col={8}>
                    <h3 className="typestack-body-2">
                        <SmartLink url={inputs.learnMoreLink}>
                            {inputs.title}
                        </SmartLink>
                    </h3>
                    <p>{inputs.text}</p>
                </KiteGridCell>
                <KiteGridCell col={4}>
                    <SmartLink
                        url={inputs.learnMoreLink}
                        ariaLabel="Learn more"
                    >
                        {gImage && (
                            <GatsbyImage
                                image={gImage}
                                alt={inputs.imageAlt ? inputs.imageAlt : ``}
                            />
                        )}
                    </SmartLink>
                </KiteGridCell>
            </KiteGrid>
        </section>
    );
};
